import React, { Component } from "react";
import { Row, Col, Button, Modal, Container, Form } from "react-bootstrap";
import Switch from "react-switch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class AddUnit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        unit: "",
        name: "",
        symbol: "",
        desc: "",
        isActive: true
      }
    };
  }

  handleChange = checked => {
    this.setState({ value: { ...this.state.value, isActive: checked } });
  };
  onChange = event => {
    let name = event.target.name;
    let value = event.target.value;
    if (name == "unit") {
      this.setState({
        value: { ...this.state.value, unit: value }
      });
    } else if (name == "name") {
      this.setState({
        value: { ...this.state.value, name: value }
      });
    } else if (name == "symbol") {
      this.setState({
        value: { ...this.state.value, symbol: value }
      });
    } else if (name == "desc") {
      this.setState({
        value: { ...this.state.value, desc: value }
      });
    }
  };

  submit = () => {
    let data = this.state.value;
    // console.log(data);

    if (
      data.unit !== "" &&
      data.name !== "" &&
      data.symbol !== "" &&
      data.desc !== ""
    ) {
      this.props.AddUnit(this.state.value);
      this.setState({
        value: {
          unit: "",
          name: "",
          symbol: "",
          desc: "",
          isActive: true
        }
      });
      this.props.closeAddModel();
      this.props.resetPage();
    } else {
      toast.error("Please fill all required fields", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    }
  };
  closeModel = () => {
    this.setState({
      value: {
        unit: "",
        name: "",
        symbol: "",
        desc: "",
        isActive: true
      }
    });
    this.props.closeAddModel();
  };
  render() {
    return (
      <div>
        <Modal
          show={this.props.showUnitAddModel}
          onHide={this.closeModel}
          animation={false}
          size="lg"
          backdrop="static"
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>Unit</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Container>
              <Form>
                <Row>
                  <Col lg={6} md={12} sm={12} xs={12}>
                    <Container>
                      <Row>
                        <Form.Group controlId="unit" style={{ width: "100%" }}>
                          <Form.Label> Basic Unit </Form.Label>
                          <Form.Control
                            type="text"
                            autoComplete="off"
                            name="unit"
                            onChange={this.onChange}
                            value={this.state.value.unit}
                          />
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group controlId="name" style={{ width: "100%" }}>
                          <Form.Label> Name </Form.Label>
                          <Form.Control
                            type="text"
                            autoComplete="off"
                            name="name"
                            onChange={this.onChange}
                            value={this.state.value.name}
                          />
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          controlId="symbol"
                          style={{ width: "100%" }}
                        >
                          <Form.Label>Symbol</Form.Label>
                          <Form.Control
                            type="text"
                            autoComplete="off"
                            name="symbol"
                            onChange={this.onChange}
                            value={this.state.value.symbol}
                          />
                        </Form.Group>
                      </Row>
                    </Container>
                  </Col>

                  <Col lg={6} md={12} sm={12} xs={12}>
                    <Container>
                      <Row>
                        <Form.Group controlId="desc" style={{ width: "100%" }}>
                          <Form.Label>Description</Form.Label>
                          <Form.Control
                            as="textarea"
                            name="desc"
                            autoComplete="off"
                            onChange={this.onChange}
                            value={this.state.value.desc}
                          />
                        </Form.Group>
                      </Row>
                      <Row>
                        <div style={{ display: "flex" }}>
                          <label style={{ display: "flex", marginTop: "8px" }}>
                            <div style={{ marginRight: "30px" }}>
                              <span>Active</span>
                            </div>
                            <div style={{ marginTop: "-5px" }}>
                              <Switch
                                onChange={this.handleChange}
                                onColor="#20a8d8"
                                checked={this.state.value.isActive}
                              />
                            </div>
                          </label>
                        </div>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Form>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button type="submit" onClick={this.submit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default AddUnit;
